export default __webpack_public_path__ + "static/media/arrow_up_black.6c09040d.svg";